import { trash } from "../../icons.js";
import BaseComponent from "../base-component.js";
import {h} from "preact"

export default class MultipleChoicePreviewComponent extends BaseComponent {
  responseCollector() {
    let choices = this.props.item.responseDeclaration.choices
    let correctAnswers = this.correctAnswers();

    if(choices) {
      let sortedChoices = choices.sort((a, b) => { return a.ordinal > b.ordinal ? 1 : -1})
      return <div class="response-collector multiple-choice">
        {sortedChoices.map((choice) => {
          return <div class="response">
            {correctAnswers.map((ca) => {
                if(ca.includes(Number(choice.id))) {
                    return <div class="label">
                        <button tabIndex={1} class="bubble selected" >{choice.identifier}</button>
                    </div>
                } else {
                    return <div class="label">
                        <button tabIndex={1} class="bubble" >{choice.identifier}</button>
                    </div>
                }
            })}
            <div class="answer-container">
              <div class="answer" dangerouslySetInnerHTML={{__html: choice.body}}></div>
            </div>
          </div>
        })}
      </div>
    }
  }

  correctAnswers() {
    let correctResponseDefinition = this.props.item.correctResponse.definition || [];
    let scoringMode = this.props.item.correctResponse.scoring_mode || "all_or_nothing";
    if(scoringMode == "all_or_nothing" || scoringMode == "spread_points_evenly") {
        return correctResponseDefinition.map((def) => def.matches);
    } else if (scoringMode == "exact_matches") {
        let maxScore = 0;
        /**
         *@type {number[][]}
        */
        let fullCreditDefs = [];
        correctResponseDefinition.forEach((def) => {
            if(def.score > maxScore) {
                maxScore = def.score;
                fullCreditDefs = [def.matches];
            } else if(def.score == maxScore) {
                fullCreditDefs.push(def.matches);
            }
        });
        return fullCreditDefs;
    } else if(scoringMode == "point_associations") {
        /**
         * @type {number[]}
         */
        let positivePointChoiceIds = [];
        (this.props.item.correctResponse.point_associations || []).forEach((pa) => {
            if(pa.points > 0) {
                positivePointChoiceIds.push(pa.choice_id);
            }
        })
        /**
         * @type {number[][]}
         */
        let defaultReturn = [];
        return positivePointChoiceIds.length == 0 ? defaultReturn : [positivePointChoiceIds]
    } else {
        throw new Error("Unsupported scoring mode: " + scoringMode);
    }
  }

  render() {
    return(
      this.wrapper(
        this.body(), this.responseCollector()
      )
    );
  }
}